import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/app/islamic-education/page.tsx");
